import { unifiedHeaderOpenModalOnLoad } from '../../../legacy/legacy';

const urlJob = '/workflow/job/add/';

const urlPreset = {
	campaign: '/workflow/campaign/add/?preset=',
	job: '/workflow/job/add/?preset=',
};

const dataInit = { campaign: 'Campaign.new', job: 'Job.new' };

export async function openWorkflowModalOnLoad(response: WorkflowVisiblePresets[] = []) {
	const visiblePresets = await response;

	if (visiblePresets.length === 0) {
		return;
	}

	const queryString = window.location.search.substring(1);

	if (queryString.includes('addjob')) {
		unifiedHeaderOpenModalOnLoad(urlJob, dataInit.job);

		return;
	}

	if (queryString.includes('preset')) {
		const parameters = queryString.split('&');
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const [_, value] = parameters.find((e) => e.includes('preset'))?.split('=') || [];
		const { type } = visiblePresets.find((p) => p.id === value) || {};

		if (type) {
			unifiedHeaderOpenModalOnLoad(urlPreset[type] + value, dataInit[type]);
		}
	}
}
